import { IBaseState } from "../../index";
import {
  IReportSendEmailModel,
  ReportSendEmailModel,
} from "../../../models/report";

/**
 *
 */
export interface ISendMessageState extends IBaseState<{}, {}> {
  service?: {};
  propertyService?: {};
  demandService?: {};
  personService?: {};
  sendEmail?: IReportSendEmailModel;
    demandInfos?: any;
    personInfos?: any;
  designedMessageTemplates?: any;
}

/**
 * define report state by vuex
 */
export class SendMessageState implements ISendMessageState {
  service?: {};
  propertyService?:{};
  demandService?: {};
  personService?: {};
  sendEmail?: IReportSendEmailModel;
    demandInfos?: any;
    personInfos?: any;
  designedMessageTemplates?: any;
  constructor(options: ISendMessageState) {
    this.sendEmail = new ReportSendEmailModel();
    this.service = options.service;
    this.propertyService = options.propertyService;
    this.demandService = options.demandService;
    this.personService = options.personService;
      this.demandInfos = options.demandInfos || [];
      this.personInfos = options.personInfos || [];
    this.designedMessageTemplates = options.designedMessageTemplates || [];
  }
}
